import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getCompanyJobAdsCountBySlug = async (slug, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  try {
    const {
      data: { count },
    } = await axios.get(`/api/public/companies/${slug}/job_ads/count?${queryString}`);

    return { count };
  } catch (error) {
    console.log(error);
  }

  return { count: 0 };
};

const defaultQueryParams = {
  includeInactive: false,
  expired: false,
  queryOptions: {},
};

export const useRelatedJobAdsCountBySlug = (slug, queryParams = {}) => {
  const { includeInactive, expired,  queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    includeinactive: includeInactive,
    onlyexpired: expired,
  };
  
  return useQuery(
    `company-${slug}-job-ads-count`,
    () => getCompanyJobAdsCountBySlug(slug, queryStringParams),
    {
      //@ts-ignore
      select: ({ count }) => ({ count }),
      initialData: { count: 0 },
      ...queryOptions,
    }
  );
}